import { render, staticRenderFns } from "./RoleTableRowOption.vue?vue&type=template&id=2129dbc2&scoped=true&"
import script from "./RoleTableRowOption.vue?vue&type=script&lang=js&"
export * from "./RoleTableRowOption.vue?vue&type=script&lang=js&"
import style0 from "./RoleTableRowOption.vue?vue&type=style&index=0&id=2129dbc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2129dbc2",
  null
  
)

export default component.exports